export var DEPLOY_DATE = new Date('2026-06-01T08:14:21+0000');
